import Colors from '@shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const ChannelListPlanPrice = styled.span`
  color: ${Colors['green']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${70 * Screen.widthRatio}px;
  letter-spacing: -${0.25 * Screen.widthRatio}px;
  line-height: ${64 * Screen.widthRatio}px;
`;

export default ChannelListPlanPrice;
